export default __webpack_public_path__ + "static/media/facebookIconCircle.5eb9fbc5.svg";